<template>
  <div>
    <section class="con5">
      <div class="container inner">
        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="linear">
          센터원에서만 만날 수 있는<br class="br-m" />
          특별한 프로그램을 소개합니다.
        </p>
        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="linear">
          센터원 시그니처<br />특강&워크숍
        </p>
        <div
          class="tab-wrap"
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-easing="linear"
        >
          <div class="tab-list">
            <ul>
              <li
                :class="{ active: this.tab === 'lecture' }"
                @click="changeWorkshopToLecture"
              >
                특강
              </li>
              <li
                :class="{ active: this.tab === 'workshop' }"
                @click="changeLectureToWorkshop"
              >
                워크샵
              </li>
            </ul>
          </div>
          <ul v-show="this.tab === 'lecture'" class="tab-con">
            <li>
              <img
                src="@/assets/img/centerone/con5/lecture1-m.png"
                alt="img"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con5/lecture1-pc.png"
                alt="img"
                class="img-pc"
              />
              <div>
                <p>리더의 의식은 어떻게 진전되는가?</p>
                <p>
                  CEO, 대기업 임원, 스타트업 리더를 위한 강연.<br />심리학,
                  뇌과학, 명상을 조합하여<br class="br-m" />
                  리더의 통찰과<br class="br-pc" />
                  의식의 매커니즘에 대한<br class="br-m" />
                  이해와 증진을 돕습니다.
                </p>
              </div>
            </li>
            <li>
              <img
                src="@/assets/img/centerone/con5/lecture2-m.png"
                alt="img"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con5/lecture2-pc.png"
                alt="img"
                class="img-pc"
              />
              <div>
                <p>이경아의 NVC로 명상하기</p>
                <p>
                  임원급, 사내 핵심 인재, 프로젝트 리더를 위한<br />명상적
                  커뮤니케이션으로 연결이 시작됩니다.
                </p>
              </div>
            </li>
          </ul>
          <ul v-show="this.tab === 'workshop'" class="tab-con">
            <li>
              <img
                src="@/assets/img/centerone/con5/workshop1-m.png"
                alt="img"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con5/workshop1-pc.png"
                alt="img"
                class="img-pc"
              />
              <div>
                <p>요즘 리더들의 명상법</p>
                <p>
                  알아차림의 기본을 배우는 시그니처 워크숍.<br />리더들의
                  집중력과 인지력을 향상시킵니다.
                </p>
              </div>
            </li>
            <li>
              <img
                src="@/assets/img/centerone/con5/workshop2-m.png"
                alt="img"
                class="img-m"
              />
              <img
                src="@/assets/img/centerone/con5/workshop2-pc.png"
                alt="img"
                class="img-pc"
              />
              <div>
                <p>허수영의 사운드베스 소리 명상</p>
                <p>
                  뇌과학과 신경계 이론을 기반으로<br />소리안에서 함께 흡하고
                  쉬어갑니다.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab: "lecture",
    };
  },

  methods: {
    changeWorkshopToLecture() {
      this.tab = "lecture";
    },

    changeLectureToWorkshop() {
      this.tab = "workshop";
    },
  },
};
</script>
<style lang="scss" scoped>
section {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.br-pc {
  display: none;

  @media screen and (min-width: 1200px) {
    display: block;
  }
}

// con5
.con5 {
  padding: 70px 0;
  overflow: hidden;

  @media screen and (min-width: 1200px) {
    padding: 150px 0;
  }

  .inner {
    padding: 0 18px;

    @media screen and (min-width: 1200px) {
      padding: 0;
    }

    > p {
      &:nth-of-type(1) {
        font-size: 20px;
        font-weight: 700;
        color: #998465;
        margin-bottom: 20px;

        @media screen and (min-width: 1200px) {
          font-size: 24px;
        }
      }

      &:nth-of-type(2) {
        font-size: 34px;
        font-weight: 700;
        margin-bottom: 20px;

        @media screen and (min-width: 1200px) {
          font-size: 64px;
          margin-bottom: 0;
        }
      }
    }

    .tab-wrap {
      .tab-list {
        display: flex;
        justify-content: flex-end;
        border-bottom: 1px solid #9f9f9f;
        padding-bottom: 20px;
        margin-bottom: 42px;

        @media screen and (min-width: 1200px) {
          padding-bottom: 50px;
          margin-bottom: 82px;
        }

        ul {
          display: flex;
          gap: 10px;

          @media screen and (min-width: 1200px) {
            gap: 40px;
          }

          li {
            position: relative;
            font-weight: 700;
            padding-bottom: 2px;
            cursor: pointer;

            @media screen and (min-width: 1200px) {
              font-size: 30px;
              padding-bottom: 4px;
            }
          }
        }
      }

      .tab-con {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 30px;

        @media screen and (min-width: 1200px) {
          grid-template-columns: repeat(2, 1fr);
          gap: 100px;
        }

        li {
          position: relative;

          .img-m {
            @media screen and (min-width: 1200px) {
              display: none;
            }
          }

          .img-pc {
            display: none;

            @media screen and (min-width: 1200px) {
              display: block;
            }
          }

          > div {
            position: absolute;
            bottom: 0;
            width: 100%;
            padding: 0 30px 30px 30px;

            @media screen and (min-width: 1200px) {
              padding: 0 60px 60px 60px;
            }

            p {
              &:nth-of-type(1) {
                font-size: 20px;
                font-weight: 700;
                color: #fff;
                margin-bottom: 10px;

                @media screen and (min-width: 1200px) {
                  font-size: 30px;
                  margin-bottom: 20px;
                }
              }

              &:nth-of-type(2) {
                color: #9f9f9f;
                line-height: 22px;

                @media screen and (min-width: 1200px) {
                  font-size: 20px;
                  line-height: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.active {
  border-bottom: 1px solid #000;
}
</style>
